export default "__VITE_PUBLIC_ASSET__a5419d03__"